import { ThumbUpIcon, UserAddIcon, StarIcon, ArrowRightIcon, DocumentSearchIcon, LockClosedIcon, PhoneIcon, PhoneIncomingIcon, PuzzleIcon } from '@heroicons/react/outline';
import TaxReliefLongForm from './Calculator/TaxReliefLongForm';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';



function LandingPageTwo(props) {

    const testimonialArray1 = [
        {
            id: 1,
            name: "Angel Reyes",
            title: "Best possible result...",
            text: "I want to thank you for everything you did to resolve my mother’s estate tax matter with IRS. You produced the best possible result. The beneficiaries are most grateful and happy to recommend you to others.",
            date: "a month ago"
        },
        {
            id: 2,
            name: "Nick Burton",
            title: "Recommend to my family...",
            text: "I would definitely give the team five stars I went there to file my taxes and got back more than I could even expect I will be going there every year from now on yes I would recommend my family.",
            date: "5 months ago"
        },
        {
            id: 3,
            name: "Antonio Montana",
            title: "Five stars...",
            text: "I've been coming to these experts for a very long time and every time I was satisfied I would recommend to my family and friends they can help you from doing your taxes to help with the IRS five stars all the way.",
            date: "5 months ago"
        },
    ]

    const testimonialArray2 = [
        {
            id: 1,
            name: "Bonnie Smith",
            title: "Highly professional and friendly service...",
            text: "I can't recommend them highly enough. They helped and guided me through every step of the way through a recent tax matter allowing me to have complete peace of mind through the whole process. Engaging with an expert like these lawyers...",
            date: "5 months ago"
        },
        {
            id: 2,
            name: "Will Dent",
            title: "Clear path forward...",
            text: "After numerous attempts to resolve the matter on our own, we went to the experts and had a great meeting with Ms. Kim. She provided us with a clear path forward and took away all the anxiety from dealing with the issue ourselves.",
            date: "5 months ago"
        },
        {
            id: 3,
            name: "Ashley Bank",
            title: "Knowledgeable, professional, and worked extremely...",
            text: "This team is phenomena! I experienced an unexpected wage garnishment and contacted the team. They are very knowledgeable, professional, and worked extremely fast as well. They resolved my tax issue within 48 hours! ",
            date: "5 months ago"
        },
        {
            id: 4,
            name: "Angel Reyes",
            title: "Best possible result...",
            text: "I want to thank you for everything you did to resolve my mother’s estate tax matter with IRS. You produced the best possible result. The beneficiaries are most grateful and happy to recommend you to others.",
            date: "a month ago"
        },
        {
            id: 5,
            name: "Nick Burton",
            title: "Recommend to my family...",
            text: "I would definitely give them five stars I went there to file my taxes and got back more than I could even expect I will be going there every year from now on yes I would recommend my family.",
            date: "5 months ago"
        },
        {
            id: 6,
            name: "Antonio Montana",
            title: "Five stars...",
            text: "I've been coming to these experts for a very long time and every time I was satisfied I would recommend to my family and friends they can help you from doing your taxes to help with the IRS five stars all the way.",
            date: "5 months ago"
        },
    ]


    return (
        <div>

            {/* Hero Section */}
            <div className='block md:hidden bg-gradient-to-br from-gray-100 to-sky-50 text-center px-2 py-4'>
                {/* <h3 className="text-white text-lg font-bold mb-1">Want help now? Call us directly!</h3> */}
                <a className="font-bold flex items-center justify-center text-gray-900 text-xl hover:underline" href="tel:8449844926">
                    <PhoneIcon className='mr-2 h-5 w-5' /> (844)984-4926</a>
            </div>
            <header className="bg-gray-600 banner px-4 py-4 md:py-20">

                <div className="max-w-7xl mx-auto md:p-10 grid lg:grid-cols-2 md:gap-10">
                    <div className='lg:order-first order-last py-2 md:py-10 text-center lg:text-left'>
                        <h1 className="text-white text-5xl md:text-7xl font-thin">Tax Resolution <span className='text-5xl md:text-8xl font-extrabold uppercase'>Experts</span></h1>
                        <h2 className="mt-3 text-white text-3xl font-bold">United Tax Attorneys</h2>
                        <p className="mt-4 text-lg md:text-xl text-gray-50">Millions of Americans fall behind on IRS tax payments each year. At United Tax Attorneys, our team of tax resolution experts in Los Angeles, California, work directly with the IRS to help you find personalized tax relief.</p>


                    </div>
                    <div className="md:order-last order-first max-w-xl mx-auto my-4 md:my-10">
                        <TaxReliefLongForm />
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main>

                {/* Section 1: Pain Points & Challenges */}
                <section className="bg-slate-50 grid grid-cols-1 lg:grid-cols-2">
                    <div className='order-2 md:order-1 relative flex justify-center items-center h-72 md:h-full md:w-full bg-gray-200'>
                        <img
                            src="/2.png"
                            alt="paper tax documents"
                            layout="fill"
                            className={`w-full h-full object-center object-cover`}
                        />
                    </div>
                    <div className='order-1 lg:order-2 px-5 md:px-10 py-10 md:py-20'>

                        <h2 className="text-gray-900 text-4xl md:text-5xl font-bold mb-8">Are You Feeling Overwhelmed by Tax Debt? <span className="font-serif text-sky-600">You’re Not Alone.</span></h2>
                        <p className='text-xl text-gray-700'>Every year, thousands of individuals and businesses struggle with tax debt issues. Whether it’s from unexpected penalties, unfiled taxes, or mounting interest fees, the IRS has methods to collect. <br /> <br /> <b className="text-black">But you have options.</b> Our team of dedicated tax debt experts can help you understand these options, <b className="text-black">negotiate with the IRS</b>, and work toward a more manageable solution. Don’t face this alone—let us support you in finding relief.</p>
                        <a href="#start" className='group'>
                            <div className="group-hover:underline text-sky-600 my-8 flex items-start mr-2 text-2xl">
                                <DocumentSearchIcon className="h-10 w-10 text-sky-600" /> Examine your current tax situation for personalized tax relief options.
                            </div>
                        </a>
                        <a href="#start" className='group'>
                            <div className="group-hover:underline text-sky-600 flex items-start mr-2 text-2xl my-8">
                                <DocumentSearchIcon className="h-10 w-10 text-sky-600" />Determine your eligibility for the IRS Fresh Start Program.
                            </div>
                        </a>
                        <a href="#start" className='group'>
                            <div className="group-hover:underline text-sky-600 flex items-start mr-2 text-2xl my-8">
                                <DocumentSearchIcon className="h-10 w-10 text-sky-600" />Work directly with the IRS to help put your tax problems behind you.
                            </div>
                        </a>
                        <div className='flex items-center justify-center gap-6'>
                            <a href="#start" className="hover:bg-sky-600 bg-white flex items-center justify-center hover:text-white text-sky-600 border-2 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-2">Get Tax Debt Help Today <ArrowRightIcon className='ml-2 md:h-4 md:w-4 h-6 w-6' /></a>
                        </div>
                    </div>

                </section>

                {/* Section 2: Solution Overview – How We Can Help */}
                <section className="bg-slate-50 grid grid-cols-1 lg:grid-cols-2">
                    <div className="order-2 lg:order-1 px-5 md:px-10 py-10 md:py-20">
                        <h2 className="text-gray-900 text-3xl md:text-5xl font-bold mb-8">How can United Tax Attorneys <span className='text-sky-600 font-serif'>Help You</span> in Tax Debt Resolution?</h2>
                        <p className='text-xl text-gray-700'>When you’re in tax debt, it can feel like there’s no way out. A qualified tax debt specialist can make a world of difference, helping you reduce penalties, negotiate payment terms, and even <b className="text-black">reduce the amount you owe</b>. <br /> <br /> Our team has helped clients just like you reach resolutions and regain peace of mind. Here’s what we can help with: <br /> <br /></p>
                        <ul className='text-gray-700 text-xl list-disc ml-10'>
                            <li className='my-4'><b className='text-black'>Penalty Reductions:</b> Negotiating to minimize or eliminate penalties.</li>
                            <li className='my-4'><b className='text-black'>Settlement Options:</b> Exploring programs like the IRS Offer in Compromise to settle your debt for less.</li>
                            <li className='my-4'><b className='text-black'>Installment Plans:</b> Setting up manageable monthly payments based on your financial situation.</li>
                            <li className='my-4'><b className='text-black'>Tax Liens and Levy Releases:</b> Working to remove liens on your assets or release wage garnishments.</li>
                        </ul>
                        <div className='flex items-center justify-center gap-6'>
                            <a href="#start" className="hover:bg-sky-600 bg-white flex items-center justify-center hover:text-white text-sky-600 border-2 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-2">Take Control of Your Financial Future <ArrowRightIcon className='ml-2 md:h-4 md:w-4 h-6 w-6' /></a>
                        </div>
                    </div>
                    <div className='order-1 lg:order-2 relative flex justify-center items-center h-72 md:h-full md:w-full bg-gray-200'>
                        <img
                            src="/3.png"
                            alt="a smiling couple shaking hands with a professional"
                            layout="fill"
                            className={`w-full h-full object-center object-cover`}
                        />
                    </div>
                </section>


                <section>
                    <div className='bg-slate-100 text-center mb-10'>
                        <div className="max-w-7xl mx-auto px-5 py-10 md:py-20 md:px-10">
                            <h3 className="text-sky-700 text-xl uppercase font-semibold tracking-wide my-4">Getting Tax Debt Help Is </h3>
                            <h2 className="text-gray-900 text-4xl md:text-5xl font-bold mb-8 font-serif">Easier Than You Think</h2>
                            <p className='max-w-4xl text-gray-700 mx-auto text-lg md:text-2xl text-center'>We know that taking the first step can be the hardest. That’s why we’ve made it simple and <b className="text-black">stress-free</b> to connect with one of our experts.</p>
                            <div className='flex items-center justify-center gap-6'>
                                <a href="#start" className="hover:bg-sky-800 bg-sky-600 text-white border-2 hover:border-sky-800 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-4 inline-block">Get Immediate Relief Today</a>
                            </div>

                            <div className='grid grid-cols-1 lg:grid-cols-3 gap-28 lg:gap-10 mt-28'>
                                <div className='bg-white border rounded-xl shadow-lg p-5 md:p-10'>
                                    <div className='-mt-28 mx-auto flex items-center justify-center border-8 bg-white mb-8 rounded-full h-40 w-40'>
                                        <PhoneIncomingIcon className='h-20 w-20 text-gray-500' />
                                    </div>
                                    <h3 className='text-gray-900 text-3xl mb-5'>Consultation</h3>
                                    <p className='text-gray-700 text-lg md:text-xl'>During the free consultation with one of our experts, we will discuss tax debt details, review IRS communications and gather relevant information to begin your personalized assessment. Our experts need vital information to see if you qualify for tax forgiveness.</p>
                                    <div className='flex items-center justify-center gap-6'>
                                        <a href="#start" className="flex items-center justify-center hover:underline text-gray-600 w-full md:w-fit text-center text-xl rounded-lg font-bold mt-6">Get Started Today <ArrowRightIcon className="ml-2 h-4 w-4" /></a>
                                    </div>
                                </div>
                                <div className='bg-white border rounded-xl shadow-lg p-5 md:p-10'>
                                    <div className='-mt-28 mx-auto flex items-center justify-center border-8 bg-white mb-8 rounded-full h-40 w-40'>
                                        <DocumentSearchIcon className='h-20 w-20 text-gray-500' />
                                    </div>
                                    <h3 className='text-gray-900 text-3xl mb-5'>Research</h3>
                                    <p className='text-gray-700 text-lg md:text-xl'>After the consultation a plan of action is presented on your behalf. First the tax authorities are contacted notifying them your are now represented by a professional tax relief attorney. Next our dedicated research team will study and compare your eligible debt forgiveness program options.</p>
                                    <div className='flex items-center justify-center gap-6'>
                                        <a href="#start" className="flex items-center justify-center hover:underline text-gray-600 w-full md:w-fit text-center text-xl rounded-lg font-bold mt-6">Get Started Today <ArrowRightIcon className="ml-2 h-4 w-4" /></a>
                                    </div>
                                </div>
                                <div className='bg-white border rounded-xl shadow-lg p-5 md:p-10'>
                                    <div className='-mt-28 mx-auto flex items-center justify-center border-8 bg-white mb-8 rounded-full h-40 w-40'>
                                        <PuzzleIcon className='h-20 w-20 text-gray-500' />
                                    </div>
                                    <h3 className='text-gray-900 text-3xl mb-5'>Resolution</h3>
                                    <p className='text-gray-700 text-lg md:text-xl'>After research, we will give a detailed breakdown on the best suited  tax resolution options for your circumstance. Our tax experts will help resolve your tax debt, obtain debt forgiveness and negotiate with the IRS and state taxing authorities.</p>
                                    <div className='flex items-center justify-center gap-6'>
                                        <a href="#start" className="flex items-center justify-center hover:underline text-gray-600 w-full md:w-fit text-center text-xl rounded-lg font-bold mt-6">Get Started Today <ArrowRightIcon className="ml-2 h-4 w-4" /></a>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>
                    <div className='my-10 md:my-20 text-center'>
                        <p className="text-sky-700 text-xl uppercase font-semibold tracking-wide my-4">Prefer to speak with someone right away?</p>
                        <a className="flex items-center justify-center font-bold text-3xl md:text-4xl hover:underline" href="tel:8449844926"> <PhoneIcon className='mr-2 h-10 w-10' /> (844)984-4926</a>
                    </div>
                </section>

                {/* Section 3: How It Works – Simple 3-Step Process */}
                <section className='mt-10 mb-20 '>
                    <div>
                        <div className="max-w-3xl mx-auto">
                            <div className='grid grid-cols-1 md:grid-cols-3 gap-3'>
                                <a href="#start">
                                    <div className='flex flex-col items-center shadow text-sky-800 bg-yellow-100 justify-center h-60 w-60  mx-auto md:h-64 md:w-full px-4 py-10'>
                                        <div className='bg-transparent text-3xl flex items-center border-dashed justify-center text-sky-800 border-sky-800 border-4 rounded-full font-bold h-14 w-14'>
                                            1
                                        </div>
                                        <h3 className='mt-2 text-gray-800 font-semibold text-2xl'>Submit Form</h3>
                                    </div>
                                </a>
                                <a href="tel:8449844926">
                                    <div className='rotate-2 flex flex-col items-center shadow text-sky-800 bg-yellow-100 justify-center h-60 w-60  mx-auto md:h-64 md:w-full px-4 py-10'>
                                        <div className='bg-transparent text-3xl flex items-center border-dashed justify-center text-sky-800 border-sky-800 border-4 rounded-full font-bold h-14 w-14'>
                                            2
                                        </div>
                                        <h3 className='mt-2 text-gray-800 font-semibold text-2xl'>Free Call</h3>
                                    </div>
                                </a>
                                <a href="#start">
                                    <div className='-rotate-12 flex flex-col items-center shadow text-green-600 bg-yellow-100 justify-center h-60 w-60  mx-auto md:h-64 md:w-full px-4 py-10'>
                                        <div className='text-3xl flex items-center  justify-center text-white bg-green-600 border-green-600 border-4 rounded-full p-5 font-bold h-14 w-14'>
                                            3
                                        </div>
                                        <h3 className='mt-2 text-gray-800 text-center font-extrabold text-3xl font-serif'>Relief Plan <p className='text-sm font-bold uppercase'>Assistance</p></h3>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='bg-white'>
                    {/* <FadeIn className='max-w-6xl mx-auto grid md:grid-cols-3 gap-4'> */}

                    <Swiper
                        // install Swiper modules
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        spaceBetween={50}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                    >
                        {testimonialArray1.map((item) => (
                            <SwiperSlide key={item.id} className="p-2 md:p-5">
                                <div className='max-w-4xl mx-auto items-center justify-center relative'>
                                    <div className='md:grid grid-cols-4 my-auto mx-5 cursor-default p-6'>
                                        <div className='col-span-1'>
                                            <div className='flex items-center justify-start'>
                                                <img src="google_logo.png" alt="Google" className='h-8 w-8' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                            </div>
                                            <p className='font-semibold text-lg mb-0 text-gray-800'>{item.name}</p>
                                            {/* <p className='font-normal text-sm mb-2 md:mb-0 text-gray-600'>{item.date}</p> */}
                                        </div>
                                        <p className='col-span-3 text-md text-left text-base md:text-lg text-gray-500 leading-5'>"{item.text}"</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </section>

                {/* end testimonials */}

                {/* Section 3: Solution Overview – How We Can Help */}
                <section className="mt-10 md:mt-20 bg-slate-50 grid grid-cols-1 lg:grid-cols-2">
                    <div className="px-5 md:px-10 py-10 md:py-20">
                        <h2 className="text-gray-900 text-3xl md:text-5xl font-bold mb-8">Your <span className='text-sky-600 font-serif'>Trusted Partner</span> in Tax Debt Resolution</h2>
                        <p className='text-xl text-gray-700'>Falling behind on tax payments to the IRS happens to <b className='text-black'>millions of Americans</b> at one time or another. Owing money to the IRS can be very intimidating, but if you are in this position don’t worry and definitely don’t lose hope – there is tax relief available with United Tax Attorneys' experts, a team of tax resolution professionals in Los Angeles, CA.
                            <br /><br />
                            Partner with a reputable tax relief company to help you reach an IRS debt forgiveness program with the IRS. Using proven strategies, our tax debt experts can assist you through tax audits, <b className='text-black'>help reduce your tax debt</b>, and stop wage garnishments or bank levies from happening. In some cases, we may be able to help you settle your tax debts for much less than what is originally owed. We, your tax relief experts, are available to be your dedicated advocate, saving you money and time.</p>

                        <div className='flex items-center justify-center gap-6'>
                            <a href="#start" className="hover:bg-sky-600 bg-white flex items-center justify-center hover:text-white text-sky-600 border-2 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-2">Speak With A Qualified Tax Relief Expert <ArrowRightIcon className='ml-2 md:h-4 md:w-4 h-6 w-6' /></a>
                        </div>
                    </div>
                    <div className='relative flex justify-center items-center h-64 md:h-full md:w-full bg-white'>
                        <img
                            src="/15.png"
                            alt="professional sitting at desk on computer"
                            layout="fill"
                            className={`w-full h-full object-center object-cover`}
                        />
                    </div>
                </section>

                <section className="bg-slate-50 grid grid-cols-1 lg:grid-cols-2">
                    <div className='order-2 lg:order-1 relative flex justify-center items-center h-64 md:h-full md:w-full bg-white'>
                        <img
                            src="/21.png"
                            alt="older couple high five in celebration at their computer"
                            layout="fill"
                            className={`w-full h-full object-center object-cover`}
                        />
                    </div>
                    <div className='order-1 lg:order-2 px-5 md:px-10 py-10 md:py-20'>

                        <h2 className="text-gray-900 text-3xl md:text-5xl font-bold mb-8">Schedule a No-Cost Consultation and <span className="font-serif text-sky-600">Free Up Your Time</span></h2>
                        <p className='text-xl text-gray-700'>Dealing with the IRS on your own can be <b className='text-black'>overwhelming and intimidating</b>. At United Tax Attorneys, our team of experts communicate directly with the IRS to assist you with all of your tax resolution needs. Our team of tax professionals and attorneys have years of experience and the highest level of tax knowledge to guide you safely, ethically, and confidently into a more secure financial position.
                            <br /> <br />
                            Whether you need  assistance in preparing for a potential tax burden in the future, help in negotiating tax liability, or representation during a tax audit, or our team of specialized, licensed tax resolution professionals provide <b className='text-black'>unwavering commitment to customer service</b>, allowing you to focus on what matters most to you.
                            <br /> <br />
                            Don’t put off dealing with your tax issues for another minute. Our tax relief specialists are <b className='text-black'>here to answer your questions</b> and give you the peace of mind that you deserve. With our tax resolution experts on your side, you can rest easy.

                        </p>
                        <div className="text-sky-600 my-8 font-semibold items-center mr-2 flex-wrap text-xl">
                            Contact United Tax Attorneys at <a className='hover:underline hover:text-black' href="tel:8449844926">(844) 984-4926</a> today to speak with one of our tax resolution experts about how we can assist you.
                        </div>

                        <div className='flex items-center justify-center gap-6'>
                            <a href="#start" className="hover:bg-sky-600 bg-white flex items-center justify-center hover:text-white text-sky-600 border-2 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-2">Take the First Step Toward Relief <ArrowRightIcon className='ml-2 md:h-4 md:w-4 h-6 w-6' /></a>
                        </div>
                    </div>

                </section>





                {/* Section 4: Testimonials and Social Proof */}
                <section className="bg-gradient-to-b from-slate-100 to-slate-200 px-5 py-10">
                    <div className="text-center">
                        <h3 className="text-sky-700 text-xl uppercase font-semibold tracking-wide my-4">See How We’ve Helped</h3>
                        <h2 className="text-gray-900 text-4xl md:text-5xl font-bold mb-8">People Just Like You</h2>
                        <p className='max-w-4xl text-gray-700 mx-auto text-lg md:text-2xl text-center'>We know that taking the first step can be the hardest. That’s why we’ve made it simple and <b className="text-black">stress-free</b> to connect with one of our experts.</p>
                        <Swiper
                            // install Swiper modules
                            modules={[Navigation, Pagination, Scrollbar, A11y]}
                            spaceBetween={50}
                            slidesPerView={1}
                            navigation
                            pagination={{ clickable: true }}
                        >
                            {testimonialArray2.map((item) => (
                                <SwiperSlide key={item.id} className="p-4 md:p-10 h-full">
                                    <div className='max-w-4xl bg-white shadow-lg rounded-xl mx-auto items-center justify-center relative'>
                                        <div className='md:grid grid-cols-4 my-auto mx-5 cursor-default p-4 md:p-6'>
                                            <div className='col-span-4'>

                                                {/* <p className='font-normal text-sm mb-2 md:mb-0 text-gray-600'>{item.date}</p> */}
                                                <p className='mb-5 text-md text-left text-base md:text-lg text-gray-800 leading-5'>"{item.text}"</p>

                                                <p className='text-left font-semibold text-lg mb-0 text-gray-800'>{item.name}</p>
                                                <div className='mt-2 flex items-center justify-left'>
                                                    <img src="google_logo.png" alt="Google" className='h-4 w-4' />
                                                    <StarIcon className='h-4 w-4 text-yellow-500' />
                                                    <StarIcon className='h-4 w-4 text-yellow-500' />
                                                    <StarIcon className='h-4 w-4 text-yellow-500' />
                                                    <StarIcon className='h-4 w-4 text-yellow-500' />
                                                    <StarIcon className='h-4 w-4 text-yellow-500' />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>




                    </div>
                </section>

                {/* <section className='bg-sky-800 px-10 py-20'>
                   

                    <Swiper
                        // install Swiper modules
                        modules={[Navigation, Pagination, Scrollbar, A11y]}
                        spaceBetween={50}
                        slidesPerView={3}
                        navigation
                        pagination={{ clickable: true }}
                    >
                        {testimonialArray2.map((item) => (
                            <SwiperSlide key={item.id} className="bg-white p-10 border h-full">
                                <div className='max-w-4xl  mx-auto items-center justify-center relative'>
                                    <div className='md:grid grid-cols-4 my-auto mx-5 cursor-default p-6'>
                                        <div className='text-center col-span-4'>
                                            <div className='flex items-center justify-center'>
                                                <img src="google_logo.png" className='h-8 w-8' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                                <StarIcon className='h-6 w-6 text-yellow-500' />
                                            </div>
                                            <p className='font-semibold text-lg mb-0 text-gray-800'>{item.name}</p>
                                            <p className='font-normal text-sm mb-2 md:mb-0 text-gray-600'>{item.date}</p>
                                            <p className='mt-5 text-md text-left text-base md:text-lg text-gray-800 leading-5'>"{item.text}"</p>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </section> */}


                {/* Section 3: Solution Overview – How We Can Help */}
                <section className="bg-slate-50 grid grid-cols-1 lg:grid-cols-2">
                    <div className="px-5 md:px-10 py-10 md:py-20">
                        <h2 className="text-gray-900 text-3xl md:text-5xl font-bold mb-8">Resolve <span className='text-sky-600 font-serif'>For Less</span> Than Owed to the IRS</h2>
                        <p className='text-xl text-gray-700'>The IRS and the states understand that <b className="text-black">not all taxpayers can pay their debts in full</b>. That's why they offer the opportunities to help resolve your tax issues while at the same time, trying to recover as much of the owed taxes as possible.
                            <br /><br />
                            Tax debt negotiation offers a potential lifeline if you owe money to the IRS or state taxing authorities. By <b className='text-black'>understanding the available options</b>, the negotiation process, and the benefits of professional assistance, you can take the necessary steps to resolve your tax liabilities and regain financial stability.</p>

                        <div className='flex items-center justify-center gap-6'>
                            <a href="#start" className="hover:bg-sky-600 bg-white flex items-center justify-center hover:text-white text-sky-600 border-2 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-6">Here to Answer Your Questions <ArrowRightIcon className='ml-2 md:h-4 md:w-4 h-6 w-6' /></a>
                        </div>
                    </div>
                    <div className='relative flex justify-center items-center h-64 md:h-full md:w-full bg-white'>
                        <img
                            src="/19.png"
                            alt="woman looking up to the sky in relief"
                            layout="fill"
                            className={`w-full h-full object-center object-cover`}
                        />
                    </div>
                </section>

                <section className="bg-slate-50 grid grid-cols-1 lg:grid-cols-2">
                    <div className='order-2 lg:order-1 relative flex justify-center items-center h-64 md:h-full md:w-full bg-white'>
                        <img
                            src="/16.png"
                            alt="hand holding a pen to a tax form"
                            layout="fill"
                            className={`w-full h-full object-center object-cover`}
                        />
                    </div>
                    <div className='order-1 lg:order-2 px-5 md:px-10 py-10 md:py-20'>
                        <h2 className="text-gray-800 text-3xl md:text-5xl font-bold mb-8">Guarantee <span className="font-serif text-sky-600">Fair Treatment</span> From The IRS </h2>
                        <p className='text-xl text-gray-700'>The <b className='text-black'>Taxpayer Bill of Rights (TBOR)</b> are rules that prevent the Internal Revenue Service (IRS) from taking advantage of you. <br /> <br /> The rules require <b className='text-black'>transparency</b> and <b className='text-black'>accountability</b> within the tax system. <br /> <br />These rights include the right to be <b className="text-black">informed</b>, receive <b className="text-black">quality service</b>, appeal decisions, and to maintain <b className='text-black'>privacy</b>. <br /> <br />Its core purpose is to empower individuals and businesses by ensuring they are treated with <b className='text-black'>dignity and respect</b> while navigating the complex and daunting federal taxation process.
                            <br />
                            <br />
                            Taxpayers have the <b className='text-black'>right to know</b> what they need to do to comply with the tax laws. <br /> <br />They are also entitled to <b className='text-black'>clear explanations</b> of the laws in all tax forms, instructions, publications, notices, and correspondence. <br /><br /> <b className='text-black'>Taxpayers have the right to raise objection</b> and provide additional documentation in response to formal actions or proposed actions.
                            <br /><br />Other taxpayer rights includes <b className='text-black'>promptly and fairly</b> considering your timely objections and documentation, plus your right to receive a response if disagreeing with their position.
                        </p>

                        <div className='flex items-center justify-center gap-6'>
                            <a href="#start" className="hover:bg-sky-600 bg-white flex items-center justify-center hover:text-white text-sky-600 border-2 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-2">Have A Tax Expert Help<ArrowRightIcon className='ml-2 md:h-4 md:w-4 h-6 w-6' /></a>
                        </div>
                    </div>

                </section>

                <section>
                    <div className='bg-slate-100 text-center'>
                        <div className="max-w-7xl mx-auto px-5 py-10 md:py-20 md:px-10">
                            <h3 className="text-sky-700 text-xl uppercase font-semibold tracking-wide my-4">Guaranteed Free</h3>
                            <h2 className="text-gray-900 text-4xl md:text-5xl font-bold mb-8">Tax Consultation Process</h2>
                            <p className='max-w-4xl text-gray-700 mx-auto text-lg md:text-2xl text-center'>We know it's hard to know where to start with tax forgiveness. That’s why we’ve made it simple and <b className="text-black">immediate</b> process to connect with one of our expert tax professionals.</p>
                            <div className='flex items-center justify-center gap-6'>
                                <a href="#start" className="mb-14 lg:mb-0 hover:bg-sky-800 bg-sky-600 text-white border-2 hover:border-sky-800 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-4 inline-block">Book Your Free Consultation</a>
                            </div>

                            <div className='grid grid-cols-1 lg:grid-cols-2 gap-28 lg:gap-10 mt-28 mb-2 md:my-20'>
                                <div className='bg-white border rounded-xl shadow-lg p-5 md:p-10'>
                                    <div className='-mt-28 mx-auto flex items-center justify-center border-8 bg-white mb-8 rounded-full h-40 w-40'>
                                        <UserAddIcon className='h-20 w-20 text-gray-500' />
                                    </div>
                                    <h3 className='text-gray-900 text-3xl mb-5'>Tons of People</h3>
                                    <div className='text-gray-700 text-lg md:text-xl'>The tax codes are confusing. Many Americans end up in a situation owing more to the IRS than they expected and can afford. <br />
                                        <div className='flex items-center justify-center gap-6'>
                                            <a href="#start" className="flex items-center justify-center hover:underline text-gray-600 w-full md:w-fit text-center text-xl rounded-lg font-bold mt-6">Looking for a different plan of action? </a>
                                        </div>
                                        <br />
                                        The IRS is the world’s most powerful collection agency. People end up with large debts to the IRS and do not get IRS debt forgiveness.  <br /> <br />If you are in this situation, the IRS can take terrifying actions like take your home, empty your bank accounts, garnish your wages, or worse.
                                        Your options are: pay the amount in full or pay over time with high interest and penalties.<br /> <br />  <div className='flex items-center justify-center gap-6'>
                                            <a href="#start" className="flex items-center justify-center hover:underline text-gray-600 w-full md:w-fit text-center text-xl rounded-lg font-bold mt-6">But there is another option! </a>
                                        </div></div>
                                    <div className='flex items-center justify-center gap-6'>
                                        <a href="tel:8449844926" className="hover:bg-sky-600 bg-white flex items-center justify-center hover:text-white text-sky-600 border-2 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-4"><PhoneIcon className='mr-2 h-6 w-6' /> Call (844) 984-4926 <ArrowRightIcon className='ml-2 md:h-4 md:w-4 h-6 w-6' /></a>
                                    </div>
                                </div>

                                <div className='bg-white border rounded-xl shadow-lg p-5 md:p-10'>
                                    <div className='-mt-28 mx-auto flex items-center justify-center border-8 bg-white mb-8 rounded-full h-40 w-40'>
                                        <ThumbUpIcon className='h-20 w-20 text-gray-500' />
                                    </div>
                                    <h3 className='text-gray-900 text-3xl mb-5'>Tax Relief Maybe The Best Option</h3>
                                    <p className='text-gray-700 text-lg md:text-xl'>We have a three-phase tax relief program that shows better results than any other firm in the industry. This is how we do it:
                                        <br /><br />

                                        <a href="#start" className="hover:underline"><b>Consultation phase -</b> Free consultation with one of our experts</a>
                                        <br /><br />
                                        <b href="#start" className="hover:underline">Investigation phase -</b> Investigate tax problems and relieve any temporary headaches
                                        <br /><br />
                                        <b href="#start" className="hover:underline">Resolution phase -</b> Prepare you for IRS Debt Forgiveness Programs for best possible outcome and prevent any future problems
                                        <br /><br />
                                        And the best part is we love doing this for our customers. We are real human beings, who enjoy helping other human beings when they need relief the most. So if you’re worried, overwhelmed, or stressed, and don’t know what to do, contact us today.</p>
                                    <div className='flex items-center justify-center gap-6'>
                                        <a href="#start" className="hover:bg-sky-600 bg-white flex items-center justify-center hover:text-white text-sky-600 border-2 border-sky-600 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-4">Get Started ASAP <ArrowRightIcon className='ml-2 md:h-4 md:w-4 h-6 w-6' /></a>
                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>

                </section>

                <section>
                    <div className='bg-gradient-to-b from-slate-100 to-slate-200 text-center pb-20 -mt-10 px-10'>
                        <h3 className="text-gray-900 text-xl uppercase font-semibold tracking-wide mb-4">Talk To An Expert Today</h3>
                        <a className="flex items-center justify-center font-bold text-gray-900 text-4xl hover:underline" href="tel:8449844926"><PhoneIcon className='mr-2 h-10 w-10' /> (844)984-4926</a>
                    </div>
                </section>


                {/* Section 5: Final CTA and Form */}
                <section>

                    <div className=' bg-sky-800 text-center'>
                        <div className="max-w-4xl mx-auto p-10 md:p-10">
                            <div className='flex items-center justify-center mb-5'>
                                <LockClosedIcon className='text-white h-20 w-20' />
                            </div>

                            <h2 className="font-serif text-white text-4xl md:text-5xl font-bold mb-2">
                                Take Control of Your Financial Future</h2>

                            <p className='text-white text-2xl max-w-4xl mx-auto'>Connect with a qualified tax debt specialist for a free consultation ASAP.</p>
                            <a href="#start" className="hover:bg-white bg-sky-800 text-white border-2  border-white tracking-wide hover:text-gray-900 w-full md:w-fit text-center py-4 px-8 text-xl rounded-lg font-semibold mt-4 inline-block">Free Consultation</a>

                        </div>
                    </div>

                </section>

            </main>
        </div>
    );
}

export default LandingPageTwo;
